import {
    PatientInformationFormState,
    PatientCreationSuccessfulAction,
    PatientInfoSendingMode,
    StagePatientDataInfoAction,
    TogglePatientInformationEditPopupAction,
    SaveEmailEditAction,
    PATIENT_OVERVIEW_EDIT_WINDOW,
    SavePhoneEditAction,
    SaveDemographicsEditAction,
    SaveAddressEditAction,
    SavePreferredPharmacyEditAction,
} from "./type";
import * as moment from "moment";

export function deepClone(obj): any {
    return JSON.parse(JSON.stringify((obj)));
}

export function setPatientCreationSuccessfulHandler(state: PatientInformationFormState, action: PatientCreationSuccessfulAction) {
    const patientInterfaceForm = deepClone(state.patientInterfaceForm);
    patientInterfaceForm.patientCreated = action.payload.status;
    return Object.assign({}, state, { patientInterfaceForm });
}
export function selectPatientInfoModeHandler(state: PatientInformationFormState, action: PatientInfoSendingMode) {
    const patientInterfaceForm = state.patientInterfaceForm;
    patientInterfaceForm.currentPatientInfoMode = action.payload.status;
    return Object.assign({}, state, { patientInterfaceForm });
}

export function stagePatientDataHandler(state: PatientInformationFormState, action: StagePatientDataInfoAction): PatientInformationFormState {
    let expDate = null;
    if (action.payload.patientInfo.healthCard.expiryDate && moment(action.payload.patientInfo.healthCard.expiryDate).isValid) {
        expDate = moment(action.payload.patientInfo.healthCard.expiryDate).utc().toISOString();
    }

    let dateOfBirth = null;
    if (action.payload.patientInfo.demographics.dateOfBirth && moment(action.payload.patientInfo.demographics.dateOfBirth).isValid()) {
        dateOfBirth = moment(action.payload.patientInfo.demographics.dateOfBirth).utc().toISOString();
    }

    const patientData = action.payload.patientInfo;

    const emails = [];
    patientData.emails.forEach((email) => emails.push({ ...email }));
    const addresses = [];
    patientData.addresses.forEach(addr => addresses.push({ ...addr }))
    const phones = [];
    patientData.phones.forEach(phone => phones.push({ ...phone }))
    return Object.assign({}, state, {
        patientInformation: {
            patientContactFacetId: patientData.patientContactFacetId,
            patientId: patientData.patientId,
            healthCard: {
                number: patientData.healthCard.number,
                expiryDate: expDate
            },
            demographics: {
                dateOfBirth,
                firstName: patientData.demographics.firstName,
                lastName: patientData.demographics.lastName,
                sexAtBirth: patientData.demographics.sexAtBirth,
                genderIdentity: patientData.demographics.genderIdentity,
                preferredName: patientData.demographics.preferredName,
                preferredPronouns: patientData.demographics.preferredPronouns,
                specifiedPreferredPronouns: patientData.demographics.specifiedPreferredPronouns,
                prefix: patientData.demographics.prefix
            },
            emails,
            addresses,
            phones,
            preferredPharmacy: patientData.preferredPharmacy
        }
    });
}

export function togglePatientInformationEditPopupHandler(state: PatientInformationFormState, action: TogglePatientInformationEditPopupAction): PatientInformationFormState {
    const patientInterfaceForm = deepClone(state.patientInterfaceForm);
    patientInterfaceForm.patientInfoEditPopupVisible = action.payload.show;
    if (action.payload.show) {
        patientInterfaceForm.patientInfoEditSelectedCategory = action.payload.type;
        if (action.payload.index || action.payload.index === 0) {
            patientInterfaceForm.patientInfoEditIndex = action.payload.index;
        } else {
            patientInterfaceForm.patientInfoEditIndex = -1;
        }
        patientInterfaceForm.patientInfoEditIsNewItem = !!action.payload.isNewItem
        return Object.assign({}, state, { patientInterfaceForm });
    } else {
        patientInterfaceForm.patientInfoEditSelectedCategory = PATIENT_OVERVIEW_EDIT_WINDOW.NONE;
        patientInterfaceForm.patientInfoEditIndex = -1;
        patientInterfaceForm.patientInfoEditIsNewItem = false
        return Object.assign({}, state, { patientInterfaceForm });
    }
}

export function saveEmailDataHandler(state: PatientInformationFormState, action: SaveEmailEditAction): PatientInformationFormState {
    return Object.assign({}, state,
        {
            patientInterfaceForm: {
                ...state.patientInterfaceForm,
                patientInfoEditPopupVisible: false
            },
            patientInfoChanged: true,
            patientInformation: {
                ...state.patientInformation,
                emails: action.payload.emails

            }
        });
}

export function savePhoneDataHandler(state: PatientInformationFormState, action: SavePhoneEditAction): PatientInformationFormState {
    return Object.assign({}, state,
        {
            patientInterfaceForm: {
                ...state.patientInterfaceForm,
                patientInfoEditPopupVisible: false
            },
            patientInfoChanged: true,
            patientInformation: {
                ...state.patientInformation,
                phones: action.payload.phones.sortByProperty(x => x.isPreferred ? 0 : 1)
            }
        });
}


export function saveAddressDataHandler(state: PatientInformationFormState, action: SaveAddressEditAction): PatientInformationFormState {
    return Object.assign({}, state,
        {
            patientInterfaceForm: {
                ...state.patientInterfaceForm,
                patientInfoEditPopupVisible: false
            },
            patientInfoChanged: true,
            patientInformation: {
                ...state.patientInformation,
                addresses: action.payload.addresses.sortByProperty(x => x.isPreferred ? 0 : 1)
            }
        });
}

export function saveDemographicsDataHandler(state: PatientInformationFormState, action: SaveDemographicsEditAction): PatientInformationFormState {
    const patientInterfaceForm = deepClone(state.patientInterfaceForm);
    patientInterfaceForm.patientInfoEditPopupVisible = false;
    const patientInformation = deepClone(state.patientInformation);
    patientInformation.demographics = action.payload.demographics;
    patientInformation.healthCard = action.payload.healthCard;
    return Object.assign({}, state, { patientInterfaceForm, patientInformation, patientInfoChanged: true });
}

export function savePreferredPharmacyDataHandler(state: PatientInformationFormState, action: SavePreferredPharmacyEditAction): PatientInformationFormState {
    const patientInterfaceForm = deepClone(state.patientInterfaceForm);
    patientInterfaceForm.patientInfoEditPopupVisible = false;
    const patientInformation = deepClone(state.patientInformation);
    patientInformation.preferredPharmacy = action.payload.preferredPharmacy;
    return Object.assign({}, state, { patientInterfaceForm, patientInformation, patientInfoChanged: true });
}


// WEBPACK FOOTER //
// ./src/store/PatientInformationForm/handlers.ts